import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { useDebouncedSearch } from 'modules/core/hooks/useSearch'

import 'modules/finance/components/FinancialWorkspacePayroll/components/Table/const'

import { useFinancialWorkspace } from '../../Providers/Provider'
import { InsightTableGroupBy } from '../../types/table'
import { ExportButton } from './components/ExportButton'
import { GroupBy } from './components/GroupBy'
import { SearchButton } from './components/SearchButton'
import PaginatedTable from './table'
import { CustomizableTableProps } from './types'

interface Props {
  tableProps: CustomizableTableProps
  defaultGroupBy: InsightTableGroupBy
}

export const Table = ({ tableProps, defaultGroupBy }: Props) => {
  const [group, setGroup] = useState<InsightTableGroupBy | undefined>()
  const { search, debouncedSearch, onSearch } = useDebouncedSearch()

  const { formattedState } = useFinancialWorkspace()

  const {
    headerTitle,
    titleResolver,
    useOnExport,
    useDataFetch,
    emptyStateProps,
    type,
    hideSearch,
  } = tableProps

  const onExport = useOnExport?.({ ...formattedState, groupBy: group || defaultGroupBy })?.onExport

  if (!useDataFetch) return null

  return (
    <Box paddingTop="s16">
      <Box
        border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
        borderRadius={{ all: 'abs016' }}
      >
        <Box flexDirection="row" justifyContent="spaceBetween" gap="s8" padding="s12">
          <Box flexDirection="row" gap="s8" alignItems="center">
            <GroupBy group={group} setGroup={setGroup} tableProps={tableProps} />
            {headerTitle && headerTitle}
          </Box>

          <Box flexDirection="row" gap="s8">
            {!hideSearch?.(group) && <SearchButton search={search || ''} onSearch={onSearch} />}

            {onExport && <ExportButton onExport={onExport} />}
          </Box>
        </Box>

        <PaginatedTable
          type={type}
          search={debouncedSearch}
          useDataFetch={useDataFetch}
          title={titleResolver(group)}
          group={group || defaultGroupBy}
          defaultGroupBy={defaultGroupBy}
          emptyStateProps={emptyStateProps}
          formattedState={formattedState}
        />
      </Box>
    </Box>
  )
}
